<template>
  <div class="guanyubody">
    <div class="w guanyuPage">
      <aboutLeft></aboutLeft>
      <div class="gy-right">
        <div class="r-title">联系我们</div>
        <div class="r-content">
          <p>
            业务介绍：
            <a href="http://www.binfen006.com/" target="_blank">
              http://www.binfen006.com/
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aboutLeft from "../components/AboutLeft";
export default {
  components: {
    aboutLeft,
  },
  data() {
    return {
      headCon: headCon(),
    };
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
  },
  mounted() {
    $("footer").show();
  },
  metaInfo() {
    return {
      title: this.headCon["guanyu"]["contact"]["title"],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.headCon["guanyu"]["contact"]["description"],
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.headCon["guanyu"]["contact"]["keywords"],
        },
      ],
    };
  },
};
</script>

<style scoped>
@import "../../assets/css/guanyu.css";
</style>